import { render, staticRenderFns } from "./customsFileGrid.vue?vue&type=template&id=1c7d1180&"
import script from "./customsFileGrid.vue?vue&type=script&lang=js&"
export * from "./customsFileGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7d1180')) {
      api.createRecord('1c7d1180', component.options)
    } else {
      api.reload('1c7d1180', component.options)
    }
    module.hot.accept("./customsFileGrid.vue?vue&type=template&id=1c7d1180&", function () {
      api.rerender('1c7d1180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/CustomsFile/components/customsFileGrid.vue"
export default component.exports